module.exports = __webpack_public_path__ + "img/42_29.0ce43567.png";